import {
  functionalUpdate,
  PaginationState,
  SortingState,
  TableOptions,
} from '@tanstack/react-table';
import { useState } from 'react';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { Table } from 'src/tables/Table';
import { EventNotification } from 'src/WebApiController';

import { useGetFilteredNotifications } from './hooks/useGetFilteredNotifications';
import { NOTIFICATIONS_TABLE_COLUMNS_CONFIG } from './NotificationsTableColumnsConfig';

export const PAGE_SIZE = 10;

export const NotificationsTable = ({ searchText }: { searchText: string }) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: PAGE_SIZE,
  });
  const [sorting, setSorting] = useState<SortingState>([
    { id: 'name', desc: false },
  ]);

  const { filteredNotifications, notificationsQuery } =
    useGetFilteredNotifications({
      searchText,
    });

  const options: Partial<TableOptions<EventNotification | null>> = {
    data: filteredNotifications ?? [],
    columns: NOTIFICATIONS_TABLE_COLUMNS_CONFIG,
    state: {
      pagination,
      sorting,
    },
    onPaginationChange: setPagination,
    onSortingChange: (sortingUpdaterFn) => {
      const newSortVal = functionalUpdate(sortingUpdaterFn, sorting);
      setSorting(newSortVal);
    },
  };
  if (filteredNotifications == null && notificationsQuery.isLoading) {
    return <PosSpinner />;
  }

  return (
    <DialogProvider>
      <Table options={options} withOuterPadding={true} roundBorders={true} />
    </DialogProvider>
  );
};
